import { useGetProfileQuery } from '@/redux/service/profile'

export const useCheckPermission = () => {
  const { data: profile, isLoading } = useGetProfileQuery()
  const hasPageAccess = (page: string): boolean => {
    if (!profile?.data?.role?.pages) return false

    return profile.data.role.pages.includes(page)
  }

  const roleName = profile?.data?.role?.name?.toLowerCase()
  const canEditSubmittedWP =
    roleName === 'administrator' ||
    roleName === 'project manager' ||
    roleName === 'pm'

  return {
    hasPageAccess,
    pages: profile?.data?.role?.pages || [],
    isLoading,
    user: profile?.data,
    isTeamLeader: profile?.data?.is_team_leader ?? false,
    team: profile?.data?.team ?? null,
    teamId: profile?.data?.team_id ?? null,
    role: profile?.data?.role?.name,
    canEditSubmittedWP,
  }
}
